import React from 'react';
import { FaBox } from 'react-icons/fa';
import { CLIENT_CATALOG } from '../../constant';

export default function ClientCatalogPageHeader() {
  return (
    <div className="client-catalog-header">
      <div className="header-content">
        <div className="d-flex align-items-center gap-3 mb-2">
          <div className="header-icon">
            <FaBox size={32} />
          </div>
          <div>
            <h1 className="mb-0">{CLIENT_CATALOG.PAGE_TITLE}</h1>
            <p className="mb-0 text-muted">{CLIENT_CATALOG.PAGE_SUBTITLE}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
